export default {
  USER_WEIGHT: 'CREMA_USER_WEIGHT',
  USER_HEIGHT: 'CREMA_USER_HEIGHT',
  WEIGHT_OPTION_ID: 'CREMA_WEIGHT_OPTION_ID',
  HEIGHT_OPTION_ID: 'CREMA_HEIGHT_OPTION_ID'
};
